import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import formatter from '../../../../common/helpers/formatter';
import type { Form } from '../../../../common/types/form';
import type { ContactAttempt } from '../../../../common/types/client';
import TextExpander from '../../../../common/components/TextExpander';

type Props = {
  contactAttempt: ContactAttempt;
  itemForm: Form<ContactAttempt>;
};

function ContactAttemptRow({ contactAttempt, itemForm }: Props) {
  const options = formatter.getFieldSelectOptions('type', itemForm.fields);
  const label = formatter.getOptionLabel(options, contactAttempt.typeOfContact);

  return (
    <Stack flex={1} direction='row' spacing={2} justifyContent='flex-start'>
      <Typography alignSelf='flex-start'>{formatter.formatGermanDate(contactAttempt.date)}</Typography>
      <TextExpander label={label} text={contactAttempt.notice} isHtml={false} />
    </Stack>
  );
}

export default ContactAttemptRow;
